import { render } from "./list-share-users-index.vue?vue&type=template&id=5b70230a&scoped=true&ts=true"
import script from "./list-share-users-index.vue?vue&type=script&lang=ts"
export * from "./list-share-users-index.vue?vue&type=script&lang=ts"

import "./list-share-users-index.vue?vue&type=style&index=0&id=5b70230a&lang=scss&scoped=true"
import "./list-share-users-index.vue?vue&type=style&index=1&id=5b70230a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b70230a"]])

export default __exports__